import { addLineItem, updateLineItemQuantity, deleteLineItem, getLineItems, getOrderMetaData, patchOrderMetaData} from "@bold-commerce/checkout-frontend-library";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getUpdatedApplicationState } from "src/library";

interface Swatch {
  shop_id: string;
  parent_variant_id: number;
  parent_sku: string;
  product_id: number;
  variant_id: string | number;
  variant_image: string;
  sku: string;
  type: string;
  option_id: number;
  option_value_id: number;
  label: string;
  swatch_image: string;
  swatch_hex: string;
}

interface Props {
  variantId: string | number;
  lineItemKey: string;
}

export function ProductSwatch({ variantId, lineItemKey }: Props) {
  const [swatches, setSwatches] = useState<Swatch[]>([]);
  const [showMore, setShowMore] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `https://bc-bold-checkout-plugin.coalition.pw/api/swatchoptions/e3gxtkmyd6/${variantId}`
      );
      const data = await response.json();
      setSwatches(data.slice(0, 10));
    };
    fetchData();
  }, [variantId]);

  const handleClick = async (swatch: Swatch) => {
    console.log("clickedtest")
    const lineItems = await getLineItems()
    const lineItem = lineItems.find(item => item.product_data.line_item_key === lineItemKey);
    const orderMetaData = await getOrderMetaData()
    const {note_attributes, notes, tags} = orderMetaData
    const cartParams = { ...orderMetaData.cart_parameters } as any;
    const { bold_subscriptions } = cartParams;
    const subItem = bold_subscriptions?.line_items_subscription_info?.find(item => item.line_item_id);

    let removeBody = {
      platform_id: JSON.stringify(swatch.parent_variant_id),
      sku: swatch.parent_sku,
      quantity: lineItem?.product_data.quantity as number,
      line_item_key: lineItemKey
    }
    await deleteLineItem(removeBody);

    const requestBody = {
      sku: swatch.sku,
      line_item_key: `${Date.now()}`,
      quantity: lineItem?.product_data.quantity as number,
      line_item_properties: lineItem?.product_data.properties
    };
    await addLineItem(requestBody);


if(subItem){
  const newLineItems = await getLineItems()
  const newLineItem = newLineItems.find(item => item.product_data.sku === swatch.sku);
  const newSubItem = { ...subItem, line_item_id: newLineItem?.product_data.line_item_key };
  const newOrderMetaData = {
    ...orderMetaData,
    cart_parameters: {
      ...cartParams,
      bold_subscriptions: {
        ...bold_subscriptions,
        line_items_subscription_info: [newSubItem]
      },
      note_attributes,
      notes,
      tags
    }
  };
  
  await patchOrderMetaData(newOrderMetaData);
}

    
    await dispatch(getUpdatedApplicationState);
  };

  const handleShowMore = () => {
    setShowMore(true);
  };

  return (
    <div>
      {swatches.map((swatch) => (
        <label
          key={swatch.option_value_id}
          className="form-option form-option-swatch"
          htmlFor={`attribute_swatch_${swatch.product_id}_${swatch.option_value_id}`}
          data-product-attribute-value={swatch.option_value_id}
        >
          <span
            className={`form-option-variant form-option-variant--pattern ${swatch.parent_variant_id === swatch.variant_id ? 'form-option-variant--swatch-selected' : ''}`}
            title={swatch.label}
            style={{ backgroundImage: `url(${swatch.swatch_image})` }}
            onClick={() => handleClick(swatch)}
          />
        </label>
      ))}
    </div>
  );
}
